import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { ACKNOWLEDGED_STATUSES } from 'models/Ecwt'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import Search from 'ui/Search'
import Text from 'ui/Text'
import DateRange from 'ui/DateRange'
import ButtonReset from 'ui/ButtonReset'
import Select from 'ui/Form/Select'

export const defaultFilters = {
  dateRangeCreated: [],
  fileName: '',
  isAcknowledge: null,
}

export const EcwtTrackerFilter = ({ filters, onFiltersChange }) => {
  const [fileName, setSearch] = useState('')

  const onFilter = (newFilters = {}) => {
    onFiltersChange({
      ...filters,
      // Always get latest search value
      fileName,
      ...newFilters,
    })
  }

  const onSearch = () => {
    if (fileName !== filters.fileName) {
      onFilter()
    }
  }

  const onSearchChange = (newValue) => {
    setSearch(newValue)
  }

  const onDateChange = (newValue) => {
    onFilter({
      dateRangeCreated: newValue,
    })
  }

  const onStatusChange = (newValue) => {
    onFilter({
      isAcknowledge: newValue,
    })
  }

  const resetClick = () => {
    // Clear search
    setSearch('')
    // Reset filter
    onFilter(defaultFilters)
  }

  return (
    <div className="mb-2">
      <Row multiline>
        <Col sm={6} md={4}>
          <Search
            id="search"
            value={fileName}
            onSearch={onSearch}
            onChange={onSearchChange}
          />
        </Col>

        <Col sm={12} md={{ narrow: true, vcenter: true }}>
          <Text paddingTop={5} paddingBottom={5}>
            Filter by
          </Text>
        </Col>

        <Col xs={6} sm={4} md={3}>
          <DateRange
            id="filter-date-added"
            value={filters.dateRangeCreated}
            placeholder="Date added"
            onChange={onDateChange}
          />
        </Col>

        <Col xs={6} sm={4} md={2}>
          {filters.isAcknowledge}
          <Select
            id="filter-status"
            value={filters.isAcknowledge}
            multiple={false}
            placeholder="Acknowledged"
            options={ACKNOWLEDGED_STATUSES}
            onChange={onStatusChange}
          />
        </Col>

        <Col xs={{ narrow: true, vcenter: true }}>
          <ButtonReset id="reset-button" onClick={resetClick} />
        </Col>
      </Row>
    </div>
  )
}

EcwtTrackerFilter.propTypes = {
  filters: PropTypes.shape({
    dateRangeCreated: PropTypes.array,
    fileName: PropTypes.string,
    isAcknowledge: PropTypes.bool,
  }),
  onFiltersChange: PropTypes.func,
}

EcwtTrackerFilter.defaultProps = {
  filters: defaultFilters,
  onFiltersChange: () => {},
}

export default EcwtTrackerFilter
